module.exports = __webpack_public_path__ + "static/media/react.cf9d26c3.png";